import { render, staticRenderFns } from "./ScheduleEdit.vue?vue&type=template&id=35e61ff0"
import script from "./ScheduleEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScheduleEdit.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports